var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-page-base",
    { attrs: { loading: _vm.loading, title: _vm.title } },
    [
      _c("div", { staticClass: "columns" }, [
        _c(
          "div",
          { staticClass: "column" },
          [
            _c(
              "sc-tabs",
              {
                attrs: { type: "is-boxed has-form" },
                model: {
                  value: _vm.typeId,
                  callback: function($$v) {
                    _vm.typeId = $$v
                  },
                  expression: "typeId"
                }
              },
              [
                _c(
                  "sc-tab-item",
                  { attrs: { label: "Todos" } },
                  [
                    _c("sc-quoting-return-all", {
                      attrs: { "return-mode-type": "ALL", "type-id": 1 }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-tab-item",
                  { attrs: { label: "Filtros" } },
                  [
                    _c("sc-quoting-return-filter", {
                      attrs: {
                        "return-mode-type": "USER_DEFINED",
                        "type-id": 2
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-tab-item",
                  { attrs: { label: "Fixos" } },
                  [
                    _c("sc-quoting-return-fixed", {
                      attrs: {
                        "return-mode-type": "FIXED_METHOD",
                        "type-id": 3
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-tab-item",
                  { attrs: { label: "Misto" } },
                  [
                    _c("sc-quoting-return-mixed", {
                      attrs: { "return-mode-type": "MIXED", "type-id": 4 }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-tab-item",
                  { attrs: { label: "Modo Detalhado" } },
                  [
                    _c("sc-quoting-return-detail", {
                      attrs: { "return-mode-type": "COMPLEX", "type-id": 5 }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "sc-tab-item",
                  { attrs: { label: "Condições Customizadas" } },
                  [
                    _c("sc-quoting-return-custom-condition", {
                      attrs: {
                        "return-mode-type": "CUSTOM_CONDITION",
                        "type-id": 6
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a3baef3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a3baef3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/quoting-return/PageQuotingReturn.vue
// module id = null
// module chunks = 